// extracted by mini-css-extract-plugin
export default {"grid":"Affiliates_grid__At3MH"};